import React from 'react'

import { PathExamplesHelp } from '../pathMapping/SourceRow'

const EXAMPLES = [
  { term: <code>call.id</code>, definition: 'nested value' },
  {
    term: <code>customFields[name=account_tier].value</code>,
    definition: 'the list item whose name is account_tier',
  },
  {
    term: <code>members[extension?].extension.number</code>,
    definition:
      'the list item that HAS an "extension" key — for payloads that label each item by key rather than by a field',
  },
  {
    term: <code>msg|json.call_id</code>,
    definition: 'decode a field whose value is JSON-encoded text, then keep going',
  },
  {
    term: <code>events.0.type</code>,
    definition:
      'by position, if the vendor guarantees order — a bare number, not events[0], which resolves to nothing',
  },
]

/**
 * Shared reference for every path field on the generic form.
 *
 * Covers all four forms parse_json_path understands. The [key?] and |json ones are
 * not guessable, and without them a payload like Yeastar's -- whole event nested in
 * an encoded string, members labelled by key -- cannot be mapped at all.
 */
export const GenericPathHelp = () => (
  <PathExamplesHelp
    intro="Paths are read from the vendor's webhook body."
    examples={EXAMPLES}
    outro="Keys are case-sensitive; the value inside [brackets] is not. Prefer selecting from a list by field or by key rather than by position — most vendors do not guarantee order."
  />
)
